
import * as d3 from 'd3'
export default {
  methods: {

    draw_Contents() {
      let viewbox = this.scroll.viewbox
      
      this.canvasContents = this.svg
      .append('g')
      .attr('transform', `translate(5, 0)`)
      .attr('font-family', 'roboto')

      this.canvasContents
      .append('defs')
      .append('clipPath')
      .attr('id', `CLIP_AREA_${this.localId}`)
      .append('rect')
      .attr('x', viewbox.x).attr('y', viewbox.y)
      .attr('width', viewbox.width).attr('height', viewbox.height)

      let clippedGroup = this.canvasContents
      .append('g')
      .attr('transform', `translate(0, 0)`)
      .attr('clip-path', `url(#CLIP_AREA_${this.localId})`)

      // clippedGroup // Stroke for temporary
      // .append('rect')
      // .attr('x', viewbox.x).attr('y', viewbox.y).attr('stroke', '#757575').attr('stroke-width', 0.5)
      // .attr('width', viewbox.width).attr('height', viewbox.height).attr('fill', 'none')
      


      // CONTENTS fro Scroll
      let dataGroup = clippedGroup
      .append('g')
      .attr('id', `CONTENTS_${this.localId}`)
      .attr('transform', `translate(${this.table.x}, ${this.scroll.viewbox.y})`)
      
      let y_ = 11
      this.rawData.forEach(d=> {

        let row = dataGroup
        .append('g')
        .attr('transform', `translate(0, ${y_})`)
        .attr('cursor', 'default')
        .call(this.call_List, d, d.SN)

        row
        .append('rect')
        .attr('id', `ROW_${d.SN}_${this.localId}`)
        .attr('x', 0).attr('y', -9)
        .attr('width', this.table.width).attr('height', 17)
        .attr('fill', '#B4E3FA').attr('opacity', 0)

        this.columns.forEach((col,c)=> {
          let x_ = c>2 ? col.tx - 6 : col.tx
          row
          .append('text')
          .attr('id', `VAL_${c}_${this.localId}`)
          .attr('transform', `translate(${x_}, ${10*0.36})`)
          .attr('font-size', 10).attr('fill', '#606060')
          .attr('text-anchor', col.align)
          .text(d[col.code])
          .call(this.event_Link, d, col, '#606060')
        })
        y_ += 18
      })

      this.scroll.content.height = y_ - 10
      this.set_ScrollValues()
    },

  }
}